import React, { useEffect, useState } from "react";
import { AddFlex, PrimaryActionButton } from "../Components/reusableStyles";
import { Drawer } from "@mui/material";
import CreateUpdatePlan from "./CreateUpdatePlan";
import { callNonStoreApi } from "../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { setPlansDataAction } from "../Store/appTempSlice";
import { FetchAllSubscriptionPlans } from "../utils/ApiEndpoints";
import PlanCard from "./PlanCard";
import RoundedBoxedTabs from "../Components/RoundedBoxedTabs";

const DRAWER_COMPONENTS = {
  features: "features",
  plan: "plan",
};

function Features() {
  const [openDrawer, setOpenDrawer] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [tabIndex, setSelectedTabIndex] = useState(0);
  const { plans } = useSelector((state) => state.appTemp.data);
  const dispatch = useDispatch();

  const getDrawerComponent = () => {
    switch (openDrawer?.requestedComponent) {
      case DRAWER_COMPONENTS.features: {
        return <>feature</>;
      }
      case DRAWER_COMPONENTS.plan: {
        return <CreateUpdatePlan selectedPlan={selectedPlan} />;
      }
      default:
        <>hey</>;
    }
  };
  const handleFetchPlans = async () => {
    try {
      const response = await callNonStoreApi(FetchAllSubscriptionPlans);
      dispatch(setPlansDataAction(response.data));
      return response.plans;
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    handleFetchPlans();
  }, []);
  return (
    <AddFlex flexDirection="column" gap="16px" margin="48px">
      <AddFlex gap="12px">
        {/* <PrimaryActionButton
          onClick={() => {
            setOpenDrawer({
              isOpen: true,
              requestedComponent: DRAWER_COMPONENTS.features,
            });
          }}
        >
          Add New Feature
        </PrimaryActionButton> */}
        <PrimaryActionButton
          onClick={() => {
            setOpenDrawer({
              isOpen: true,
              requestedComponent: DRAWER_COMPONENTS.plan,
            });
          }}
        >
          Create New Plan
        </PrimaryActionButton>
      </AddFlex>
      <AddFlex justify="center">
        <RoundedBoxedTabs
          selectedTabIndex={tabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
          tabs={[{ name: "Billed Monthly" }, { name: "Billed Annually" }]}
        />
      </AddFlex>

      <AddFlex gap="10px" justify="center">
        {plans?.map((plan) => (
          <PlanCard
            plan={plan}
            isMonthly={tabIndex === 0}
            onPlanSelected={() => {
              setSelectedPlan(plan);
              setOpenDrawer({
                isOpen: true,
                requestedComponent: DRAWER_COMPONENTS.plan,
              });
            }}
          />
        ))}
      </AddFlex>
      <Drawer
        onClose={() => setOpenDrawer(null)}
        anchor="right"
        open={openDrawer?.isOpen}
        PaperProps={{
          sx: {
            width: "50vw",
            padding: "20px",
          },
        }}
      >
        {getDrawerComponent()}
      </Drawer>
    </AddFlex>
  );
}

export default Features;
